/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-c3f1141e.js';
import { _ as _baseGetTag } from './dep-4941ebe7.js';
import { i as isObjectLike_1 } from './dep-7dce2c26.js';

var baseGetTag = _baseGetTag,
  isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
var isBoolean_1 = isBoolean;

export { isBoolean_1 as i };
//# sourceMappingURL=dep-7dad86aa.js.map
